import { helpers } from "@shared";
import { DropdownSelect, DropdownOption, DropdownSelectLabeledTrigger } from "@common";

interface PaymentDayProps {
    maxDay: number | null;
    dueDay: number | null;
    setDueDay: (day: number) => void;
    locked?: boolean;
    isAutopayLate?: boolean;
    isACH?: boolean;
    id?: string;
}

const PaymentDay = ({ maxDay, dueDay, setDueDay, locked = false, isAutopayLate = false, isACH = false, id }: PaymentDayProps) => (
    <>
        <DropdownSelect
            trigger={(props) => <DropdownSelectLabeledTrigger label="Run Autopay On" disabled={locked} id={id} {...props} />}
            value={dueDay}
            onChange={setDueDay}
            matchTriggerWidth
        >
            {Array.from({ length: maxDay ?? 0 }, (_, i) => i + 1).map(day => (
                <DropdownOption key={day} value={day}>
                    {`${helpers.dayOrdinal(day)} of the month`}
                </DropdownOption>
            ))}
        </DropdownSelect>
        <div className="flex flex-col gap-2">
            <p className="text-sm leading-5 font-normal text-neutral-800 tracking-[0.14px]">
                Your community’s autopay date is the {helpers.dayOrdinal(dueDay)} of the month. On the {helpers.dayOrdinal(dueDay)}, your full balance will be paid using your default payment method.
            </p>
            {isACH && (
                <p className="text-sm leading-5 font-normal text-neutral-600 tracking-[0.14px]">
                    To ensure payments are on time, ACH payments will process the business day before the date selected.
                </p>
            )}
        </div>
        {isAutopayLate &&
            <div id="autopay-late-alert">
                <span className="text-sm leading-5 font-normal text-red-600 tracking-[0.14px]">
                    Your auto-draw day is in the past. If you have an outstanding balance, please make a one-time payment for this month’s balance.
                </span>
            </div>
        }
    </>
);

export default PaymentDay;
